(function (algolia) {
  "use strict";

  /* Store variables */
  algolia.storeName = window.location.hostname
    .replace(/^www\./, "")
    .replace(/^([^.]*)\..*$/, "$1");

  /**
   * Checks whether we are on the `/search` page
   */
  algolia.full_results = Boolean(window.location.href.match(/\/search/));

  /**
   * Checks whether we are on a collection page
   */
  algolia.is_collection_results_page = Boolean(
    // We want to match `/collections/handle` but only if handle != 'all'
    window.location.pathname.match(
      /(^\/\w{2}\/|^\/|^\/\w{2}-\w{2}\/)collections\/(?!all$)([^/]+)[/]*$/
    )
    /**
     * To match /collections/handle/handle-two links as well, please use
     * the following regex instead:
     */
    // window.location.pathname.match(/(^\/\w{2}\/|^\/|^\/\w{2}-\w{2}\/)collections\/(?!all)(.*)$/)
  );

  /* Hide page content during InstantSearch loading */
  var collectionPageEnabled =
    algolia.is_collection_results_page &&
    algolia.config.instant_search_enabled_on_collection;
  var results_selector = collectionPageEnabled
    ? algolia.config.collection_css_selector
    : algolia.config.results_selector;
  results_selector += ", .algolia-shopify-instantsearch";

  // if (
  //   (algolia.full_results && algolia.config.instant_search_enabled) ||
  //   collectionPageEnabled
  // ) {
  //   algolia.contentHide = new DOMParser().parseFromString(
  //     '<style>' + results_selector + ' { visibility: hidden }</style>',
  //     'text/html'
  //   ).head.firstElementChild;
  //   document.head.append(algolia.contentHide);
  // }

  algolia.getTemplate = function getTemplate(name) {
    var el = document.getElementById("template_algolia_" + name);
    return el ? el.innerHTML : "";
  };

  // Current collection page ID
  var current_collection_id_string = algolia
    .getTemplate("current_collection_id")
    .replace(/^\s+|\s+$/g, "");

  if (current_collection_id_string) {
    try {
      var current_collection_id_object = JSON.parse(
        current_collection_id_string
      );
      algolia.current_collection_id =
        current_collection_id_object.currentCollectionID;
    } catch (error) {
      // Encountered an error while trying to parse the collection ID.
      // This most probably means that we aren't on a collection page.
    }
  }

  /* Add CSS block after current script */
  algolia.appendStyle = function appendStyle(content) {
    var scripts = document.getElementsByTagName("script");
    var currentScript = scripts[scripts.length - 1];
    var style = document.createElement("style");
    style.innerHTML = content;
    currentScript.parentNode.insertBefore(style, currentScript.nextSibling);
  };

  algolia.assign = function assign(to) {
    for (var i = 1; i < arguments.length; i++) {
      var nextSource = arguments[i];
      for (var nextKey in nextSource) {
        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
          to[nextKey] = nextSource[nextKey]; // eslint-disable-line no-param-reassign
        }
      }
    }
    return to;
  };

  /* Here because we need to ensure we have a fallback with '$ {{ amount }}'. */
  let shop_currency_format = null;
  if (
    algolia.config.markets_indexing_enabled &&
    algolia.config.markets_mapping.length > 1
  ) {
    shop_currency_format = algolia
      .getTemplate("multicurrency_default_format")
      .split(":");
  }

  algolia.money_format = algolia
    .getTemplate("money_format")
    .replace(/^\s+|\s+$/g, "");
  algolia.formatMoney = function formatMoney(cents, currency_code = false) {
    var priceInCents = cents;


    var val = (priceInCents / 100.0).toLocaleString("en", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    var format = algolia.money_format;
    // Replace the money_format when we have a mix of contextual market pricing and store default pricing
    // we need to ensure the currency symbol reflects the correct currency/prices.
    if (shop_currency_format && shop_currency_format[0] == currency_code) {
      const fallback_format = shop_currency_format[1].replace(/^\s+|\s+$/g, "");
      format = fallback_format;
    }

    // Not necessary, but allows for more risk tolerance if Shopify.formatMoney doesn't work as we want
    var regexp = /^([^{}]*)\{\{amount\}\}([^{}]*)$/;
    if (format.match(regexp)) {
      return format.replace(regexp, "$1" + val + "$2");
    }

    regexp = /^([^{}]*)\{\{amount_with_comma_separator\}\}([^{}]*)$/;
    if (format.match(regexp)) {
      var money = val.replace(/[.]/, "|");
      money = money.replace(/[,]/, ".");
      money = money.replace(/[|]/, ",");
      return format.replace(regexp, "$1" + money + "$2");
    }

    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(priceInCents, format);
    }

    return "$" + val;
  };
})(window.algoliaShopify);

/*
  Initialize the search client

  If you're logged into the Algolia dashboard, the following values for
  undefined and undefined are auto-selected from
  the currently selected Algolia application.
*/

const { liteClient: algoliasearch } = window["algoliasearch/lite"];
const { app_id, search_api_key, index_prefix, show_products } =
  window.algoliaShopify.config;

const searchClient = algoliasearch(app_id, search_api_key);

// Detect Shopify query param (only exists on search page)
const urlParams = new URLSearchParams(window.location.search);
const shopifyQuery = urlParams.get("q") || "";

// Init InstantSearch
const search = instantsearch({
  indexName: "shopify_products",
  searchClient,
  routing: {
    stateMapping: instantsearch.stateMappings.singleIndex("shopify_products"),
  },
  analytics: false,
  insights: false,
  initialUiState: {
    shopify_products: {
      query: shopifyQuery,
    },
  },
});
// Get collection handle from URL
function getCollectionHandleFromURL() {
  const matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
  return (matches && matches.length === 2) ? matches[1] : null;
}

const collectionHandle = getCollectionHandleFromURL();

if (collectionHandle) {
  console.log("Filtering by collection handle:", collectionHandle);

  search.addWidgets([
    instantsearch.widgets.configure({
      filters: `collections:"${collectionHandle}"` // Use handles instead of IDs
    })
  ]);
}
// Optional: keep Algolia in sync if Shopify query changes dynamically
search.addWidgets([
  instantsearch.widgets.configure({
    query: shopifyQuery,
  }),
]);


//------------------------------------Filter load start--------------------------------------------------------

// containers (desktop + mobile)
const facetContainer = document.querySelector("#algolia-facets-container");
const facetContainerMobile = document.querySelector("#algolia-facets-container-mobile") || document.querySelector(".mobile-facets__main");

// facets config
const facets = window.algoliaShopify.config.collection_facets?.default || window.algoliaShopify.config.facets || [];

// build title map (optional)
const facetTitleMap = {};
facets.forEach(f => {
  const keyTitle = (f.title || f.label || f.name).replace(/[^a-zA-Z0-9-_]/g, '').toLowerCase();
  const displayTitle = f.title || f.label || f.name;
  facetTitleMap[f.name] = displayTitle;
  facetTitleMap[keyTitle] = displayTitle;
});
// console.log("facetTitleMap", facetTitleMap);

// helper to create the summary HTML
function createSummaryHTML(title) {
  let displayTitle = title;
  if (window.algoliaShopify && window.algoliaShopify.translations && window.algoliaShopify.translations.facets) {
    const t = window.algoliaShopify.translations.facets;
    if (t[title]) {
      displayTitle = t[title];
    } else if (t[title.trim()]) {
      displayTitle = t[title.trim()];
    }
  }
  return `
    <span class="facets__selected">${displayTitle}</span>
    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-caret" viewBox="0 0 24 15">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"></path>
    </svg>
  `;
}

// ensure mobile container cleared (if present)
if (facetContainerMobile) facetContainerMobile.innerHTML = "";

// iterate and create both desktop + mobile facet blocks
if (Array.isArray(facets)) {
  facets.forEach(facet => {
    if (!facet.enabled) return;

    const safeName = facet.name.replace(/[^a-zA-Z0-9-_]/g, '-');
    const idDesktop = `facet-${safeName}`;
    const idMobile = `facet-${safeName}-mobile`;
    const clearDesktop = `clear-${safeName}`;
    const clearMobile = `clear-${safeName}-mobile`;

    // --- desktop nodes ---
    const detailsDesktop = document.createElement('details');
    detailsDesktop.className = 'js-filter algolia-facet-wrapper';
    detailsDesktop.dataset.index = facet.name;
    detailsDesktop.open = true;

    const summaryDesktop = document.createElement('summary');
    summaryDesktop.className = 'facets__header';
    summaryDesktop.innerHTML = createSummaryHTML(facet.title || facet.label);

    const blockDesktop = document.createElement('div');
    blockDesktop.id = idDesktop;
    blockDesktop.className = 'algolia-facet-block';

    const clearDivDesktop = document.createElement('div');
    clearDivDesktop.id = clearDesktop;
    clearDivDesktop.className = 'algolia-clear-refinement';

    // append desktop
    detailsDesktop.appendChild(summaryDesktop);
    detailsDesktop.appendChild(blockDesktop);
    blockDesktop.appendChild(clearDivDesktop);
    if (facetContainer) facetContainer.appendChild(detailsDesktop);

    // --- mobile nodes (only if mobile container exists) ---
    let blockMobile = null;
    if (facetContainerMobile) {
      const detailsMobile = document.createElement('details');
      detailsMobile.className = 'js-filter algolia-facet-wrapper mobile';
      detailsMobile.dataset.index = facet.name;
      detailsMobile.open = true;

      const summaryMobile = document.createElement('summary');
      summaryMobile.className = 'facets__header';
      summaryMobile.innerHTML = createSummaryHTML(facet.title || facet.label);

      blockMobile = document.createElement('div');
      blockMobile.id = idMobile;
      blockMobile.className = 'algolia-facet-block';

      const clearDivMobile = document.createElement('div');
      clearDivMobile.id = clearMobile;
      clearDivMobile.className = 'algolia-clear-refinement';

      // append mobile
      detailsMobile.appendChild(summaryMobile);
      detailsMobile.appendChild(blockMobile);
      blockMobile.appendChild(clearDivMobile);
      facetContainerMobile.appendChild(detailsMobile);
    }

    // --- register widgets for facet (desktop + mobile) ---
    // We'll create widget array and push desktop + (if present) mobile versions
    const widgets = [];

    if (facet.name === 'price_range') {
      // slider + label ids
      const sliderDesktop = `${idDesktop}-slider`;
      console.log(sliderDesktop, 'sliderDesktop');
      const labelDesktop = `${idDesktop}-label`;

      // create dom nodes for desktop slider/label
      const sd = document.createElement('div'); sd.id = sliderDesktop; blockDesktop.appendChild(sd);
      const ld = document.createElement('div'); ld.id = labelDesktop; ld.className = 'price-range-label'; blockDesktop.appendChild(ld);

      if (facetContainer) {
        widgets.push(
          instantsearch.widgets.rangeSlider({ container: `#${sliderDesktop}`, attribute: 'price', tooltips: true, cssClasses: { root: 'ais-RangeSlider' } }),
          instantsearch.widgets.clearRefinements({ container: `#${clearDesktop}`, includedAttributes: ['price'], templates: { resetLabel: algoliaShopify.translations.reset || 'Reset' }, cssClasses: { button: 'algolia-clear-button' } }),
          instantsearch.widgets.stats({
            container: `#${labelDesktop}`, templates: {
              text: (_, { results }) => {
                if (!results) return '';
                const stats = results.getFacetStats?.('price');
                const min = stats?.min || 0; const max = stats?.max || 0;
                return `Price: AED. ${Math.floor(min)} – AED. ${Math.ceil(max)}`;
              }
            }
          })
        );
      }

      if (blockMobile) {
        const sliderMobile = `${idMobile}-slider`;
        const labelMobile = `${idMobile}-label`;
        const sm = document.createElement('div'); sm.id = sliderMobile; blockMobile.appendChild(sm);
        const lm = document.createElement('div'); lm.id = labelMobile; lm.className = 'price-range-label'; blockMobile.appendChild(lm);

        widgets.push(
          instantsearch.widgets.rangeSlider({ container: `#${sliderMobile}`, attribute: 'price', tooltips: true, cssClasses: { root: 'ais-RangeSlider' } }),
          // instantsearch.widgets.clearRefinements({ container: `#${clearMobile}`, includedAttributes: ['price'], templates: { resetLabel: 'Reset' }, cssClasses: { button: 'algolia-clear-button' } }),
          instantsearch.widgets.stats({
            container: `#${labelMobile}`, templates: {
              text: (_, { results }) => {
                if (!results) return '';
                const stats = results.getFacetStats?.('price');
                const min = stats?.min || 0; const max = stats?.max || 0;
                return `Price: AED. ${Math.floor(min)} – AED. ${Math.ceil(max)}`;
              }
            }
          })
        );
      }
    }
    else if (facet.name === 'options.color') {
      if (facetContainer) {
        widgets.push(
          instantsearch.widgets.refinementList({
            container: `#${idDesktop}`,
            attribute: 'options.color',
            templates: {
              item(data) {
                const key = data.value.trim().toLowerCase(); // Use value (English) for swatch lookup
                const c = SWATCH_MAP[key] || key.replace(/\s+/g, '');

                let displayLabel = data.label;
                if (window.algoliaShopify.translations && window.algoliaShopify.translations.facetValues) {
                  const trans = window.algoliaShopify.translations.facetValues;
                  // Try translating label or value
                  if (trans[data.label]) displayLabel = trans[data.label];
                  else if (trans[data.value]) displayLabel = trans[data.value];
                }

                return `
                  <label class="color-swatch-wrapper" data-facet="color" title="${displayLabel}">
                    <input data-id="color" type="checkbox" value="${data.value}" ${data.isRefined ? 'checked' : ''} class="color-swatch-input" />
                    <span class="color-swatch" style="background-color:${c}">
                      <span class="color-swatch-dot"></span>
                    </span>
                  </label>
                `;
              }
            },
            cssClasses: { list: 'color-swatch-list' },
          }),
          instantsearch.widgets.clearRefinements({
            container: `#${clearDesktop}`,
            includedAttributes: [facet.name],
            templates: { resetLabel: algoliaShopify.translations.reset || 'Reset' },
            cssClasses: { button: 'algolia-clear-button' }
          })
        );
      }

      if (blockMobile) {
        widgets.push(
          instantsearch.widgets.refinementList({
            container: `#${idMobile}`,
            attribute: 'options.color',
            templates: {
              item(data) {
                const key = data.value.trim().toLowerCase(); // Use value (English) for swatch lookup
                const c = SWATCH_MAP[key] || key.replace(/\s+/g, '');

                let displayLabel = data.label;
                if (window.algoliaShopify.translations && window.algoliaShopify.translations.facetValues) {
                  const trans = window.algoliaShopify.translations.facetValues;
                  // Try translating label or value
                  if (trans[data.label]) displayLabel = trans[data.label];
                  else if (trans[data.value]) displayLabel = trans[data.value];
                }

                return `
                  <label class="color-swatch-wrapper" data-facet="color" title="${displayLabel}">
                    <input data-id="color" type="checkbox" value="${data.value}" ${data.isRefined ? 'checked' : ''} class="color-swatch-input" />
                    <span class="color-swatch" style="background-color:${c}">
                      <span class="color-swatch-dot"></span>
                    </span>
                  </label>
                `;
              }
            },
            cssClasses: { list: 'color-swatch-list' },
          })
        );
      }
    }
    else {
      const widgetType = facet.type === 'menu' ? 'menu' : 'refinementList';
      if (facetContainer) {
        widgets.push(
          instantsearch.widgets[widgetType]({
            container: `#${idDesktop}`,
            attribute: facet.name,
            templates: { header: '' },
            sortBy: facet.sortBy || ['name:asc'],
            transformItems(items) {
              return items.map(item => {
                let newLabel = item.label;
                if (window.algoliaShopify.translations && window.algoliaShopify.translations.facetValues) {
                  const trans = window.algoliaShopify.translations.facetValues;
                  if (trans[item.value]) {
                    newLabel = trans[item.value];
                  } else if (trans[item.label]) {
                    newLabel = trans[item.label];
                  }
                }
                return { ...item, label: newLabel, highlighted: newLabel };
              });
            }
          }),
          instantsearch.widgets.clearRefinements({ container: `#${clearDesktop}`, includedAttributes: [facet.name], templates: { resetLabel: algoliaShopify.translations.reset || algoliaShopify.translations.reset || 'Reset' }, cssClasses: { button: 'algolia-clear-button' } })
        );
      }
      if (blockMobile) {
        widgets.push(
          instantsearch.widgets[widgetType]({
            container: `#${idMobile}`,
            attribute: facet.name,
            templates: { header: '' },
            sortBy: facet.sortBy || ['name:asc'],
            transformItems(items) {
              return items.map(item => {
                let newLabel = item.label;
                if (window.algoliaShopify.translations && window.algoliaShopify.translations.facetValues) {
                  const trans = window.algoliaShopify.translations.facetValues;
                  if (trans[item.value]) {
                    newLabel = trans[item.value];
                  } else if (trans[item.label]) {
                    newLabel = trans[item.label];
                  }
                }
                return { ...item, label: newLabel, highlighted: newLabel };
              });
            }
          }),
          // instantsearch.widgets.clearRefinements({ container: `#${clearMobile}`, includedAttributes: [facet.name], templates: { resetLabel: 'Reset' }, cssClasses: { button: 'algolia-clear-button' } })
        );
      }
    }

    // finally register widgets for this facet
    if (widgets.length) search.addWidgets(widgets);
  });
  // after facets.forEach loop ends
  if (facetContainerMobile) {
    // Hide native Shopify mobile footers to prevent double-footers and conflicts
    document.querySelectorAll('.mobile-facets__main > .mobile-facets__footer').forEach(el => {
      el.style.display = 'none';
    });

    const footer = document.createElement('div');
    footer.className = "no-js-hidden mobile-facets__footer";
    footer.innerHTML = `
      <button type="button" class="no-js-hidden button">Apply</button>
      <div class="facet-remove-algolia" style="display: inline-block; font-size: 1.6rem;">
        <a href="/collections/mens-collection" class="mobile-facets__clear link link--underline">Clear</a>
      </div>
      <noscript><button class="button">Apply</button></noscript>
    `;

    facetContainerMobile.appendChild(footer);
  }
  // -----------------------------
  function attachShowMore(ul, maxVisible = 5) {
    const items = ul.querySelectorAll("li");
    if (!items.length) return;

    // wrap list inside a container if not already
    if (!ul.parentElement.classList.contains("show-more-wrapper")) {
      const wrapper = document.createElement("div");
      wrapper.className = "show-more-wrapper";
      ul.parentNode.insertBefore(wrapper, ul);
      wrapper.appendChild(ul);
    }

    const wrapper = ul.parentElement;

    // always create/reuse button
    let btn = wrapper.nextElementSibling;
    if (!btn || !btn.classList.contains("button-show-more")) {
      btn = document.createElement("show-more-button");
      btn.className = "button-show-more no-js-hidden";
      btn.innerHTML = `
      <span class="icon-wrapper" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-horizontal-dots" viewBox="0 0 20 20" fill="none">
          <path d="M10.001 7.8c-1.215 0-2.201 0.985-2.201 2.2s0.986 2.2 2.201 2.2c1.215 0 2.199-0.985 2.199-2.2s-0.984-2.2-2.199-2.2zM3.001 7.8c-1.215 0-2.201 0.985-2.201 2.2s0.986 2.2 2.201 2.2c1.215 0 2.199-0.986 2.199-2.2s-0.984-2.2-2.199-2.2zM17.001 7.8c-1.215 0-2.201 0.985-2.201 2.2s0.986 2.2 2.201 2.2c1.215 0 2.199-0.985 2.199-2.2s-0.984-2.2-2.199-2.2z" fill="currentColor"/>
        </svg>
      </span>
      <span class="label-show-more">Show more</span>
      <span class="label-show-less hidden">Show less</span>
    `;
      wrapper.insertAdjacentElement("afterend", btn);
    }

    const labelMore = btn.querySelector(".label-show-more");
    const labelLess = btn.querySelector(".label-show-less");

    // ✅ Dynamically hide/show dots based on item count
    if (items.length <= maxVisible) {
      btn.classList.add("hidedots");
    } else {
      btn.classList.remove("hidedots");
    }


    // if <= maxVisible, reset wrapper height
    if (items.length <= maxVisible) {
      wrapper.style.maxHeight = "none";
      wrapper.dataset.expanded = "false";
      return; // no need for show-more logic
    }

    const firstItems = Array.from(items).slice(0, maxVisible);
    const collapsedHeight = firstItems.reduce((h, li) => h + li.offsetHeight, 0);

    if (!wrapper.dataset.expanded) wrapper.dataset.expanded = "false";

    if (wrapper.dataset.expanded === "true") {
      wrapper.style.maxHeight = ul.scrollHeight + "px";
    } else {
      wrapper.style.maxHeight = collapsedHeight + "px";
    }

    wrapper.style.overflow = "hidden";
    wrapper.style.transition = "max-height 0.3s ease";

    btn.addEventListener("click", () => {
      if (wrapper.dataset.expanded === "true") {
        wrapper.dataset.expanded = "false";
        wrapper.style.maxHeight = collapsedHeight + "px";
        labelMore.classList.remove("hidden");
        labelLess.classList.add("hidden");
      } else {
        wrapper.dataset.expanded = "true";
        wrapper.style.maxHeight = ul.scrollHeight + "px";
        labelMore.classList.add("hidden");
        labelLess.classList.remove("hidden");
      }
    });
  }

  // -----------------------------
  // Run only for screens >= 750px
  // -----------------------------
  function initShowMore() {
    if (window.matchMedia("(min-width: 750px)").matches) {
      document.querySelectorAll(".ais-RefinementList-list").forEach(ul => {
        if (ul.classList.contains("color-swatch-list")) return;
        attachShowMore(ul, 5);
      });
    }
  }

  // run on first load
  initShowMore();

  // re-run after each Algolia render
  search.on("render", () => {
    initShowMore();
    // Hide empty facet wrappers
    document.querySelectorAll('.algolia-facet-wrapper').forEach(wrapper => {
      const block = wrapper.querySelector('.algolia-facet-block');
      if (block) {
        const hasNoRefinement = block.querySelector('.ais-RefinementList--noRefinement, .ais-Menu--noRefinement, .ais-RangeSlider--noRefinement');
        if (hasNoRefinement) {
          wrapper.style.display = 'none';
        } else {
          wrapper.style.display = '';
        }
      }
    });
  });

  // re-check when resizing window
  window.addEventListener("resize", () => {
    initShowMore();
  });




  /* ============================
     MOBILE FACETS WITH BODY ANIMATIONS + APPLY/CLEAR LOGIC
     ============================ */
  document.addEventListener("DOMContentLoaded", function () {

    // Sticky active facets (unchanged)
    const container = document.querySelector('.active-facets-mobile');
    const stickyElement = document.querySelector('.product-grid-container');

    if (container && stickyElement) {
      window.addEventListener('scroll', function () {
        const stickyTop = stickyElement.getBoundingClientRect().top;
        if (stickyTop <= 1) {
          container.classList.add('scrolled');
        } else {
          container.classList.remove('scrolled');
        }
      });
    }

    function initMobileFacets() {

      const CURRENT_REFINEMENTS_WRAPPER = '.active-facets-wrapper';
      const CLEAR_REFINEMENTS_WRAPPER = '.ais-CurrentRefinements-active-facets';

      if (!document.querySelector('style[data-hidden-until-apply]')) {
        const style = document.createElement('style');
        style.setAttribute('data-hidden-until-apply', 'true');
        // style.textContent = `.hidden-until-apply{display:none !important;}`;
        document.head.appendChild(style);
      }

      const mobileDrawer = document.querySelector('details.disclosure-has-popup.large-up-hide.medium-hide');
      const mobileSummary = mobileDrawer ? mobileDrawer.querySelector('summary') : null;
      const body = document.body;

      function hideActiveFacets() {
        document.querySelectorAll(`${CURRENT_REFINEMENTS_WRAPPER}, ${CLEAR_REFINEMENTS_WRAPPER}`)
          .forEach(el => el && el.classList.add('hidden-until-apply'));
      }

      function showActiveFacets() {
        document.querySelectorAll(`${CURRENT_REFINEMENTS_WRAPPER}, ${CLEAR_REFINEMENTS_WRAPPER}`)
          .forEach(el => el && el.classList.remove('hidden-until-apply'));
      }

      hideActiveFacets();

      let allowDrawerClose = false;

      function forceDrawerOpen() {
        if (!mobileDrawer) return;

        // Animate opening
        body.classList.add('facet-drawer--opening');
        setTimeout(() => {
          if (!mobileDrawer.open) {
            body.classList.remove('facet-drawer--opening');
            return;
          }
          body.classList.remove('facet-drawer--opening');
          body.classList.add('facet-drawer--open');
        }, 100); // short delay for animation

        mobileDrawer.open = true;
        mobileDrawer.classList.add('menu-opening');
        mobileDrawer.classList.remove('menu-closing');
      }

      function forceDrawerClose() {
        if (!mobileDrawer) return;

        body.classList.remove('facet-drawer--open');
        body.classList.add('facet-drawer--closing');
        setTimeout(() => body.classList.remove('facet-drawer--closing'), 200);

        mobileDrawer.open = false;
      }

      // OPEN drawer on click (except footer)
      if (mobileDrawer) {
        mobileDrawer.addEventListener('click', (e) => {
          if (e.target.closest('.mobile-facets__footer')) return;
          if (!allowDrawerClose) forceDrawerOpen();
        }, true);

        if (mobileSummary) {
          mobileSummary.addEventListener('click', (e) => {
            if (mobileDrawer.open && !allowDrawerClose) {
              e.preventDefault();
              e.stopImmediatePropagation();
              forceDrawerOpen();
            }
          }, true);
        }

        mobileDrawer.addEventListener('toggle', () => {
          if (!mobileDrawer.open) {
            if (!allowDrawerClose) {
              requestAnimationFrame(forceDrawerOpen);
            } else {
              body.classList.remove('facet-drawer--open');
            }
          } else {
            // Reopen all facet groups when drawer opens
            mobileDrawer.querySelectorAll('details.js-filter').forEach(d => {
              d.open = true;
            });
          }
        });
      }

      // CLOSE drawer when close button clicked (delegated)
      document.addEventListener('click', (e) => {
        const closeBtn = e.target.closest('.ap_mobile-facets__close');
        if (!closeBtn || !mobileDrawer || !mobileSummary) return;
        if (closeBtn.closest('.aa-PanelLayout') || closeBtn.closest('.autocomplete-facets-mobile')) return;

        e.preventDefault();
        e.stopPropagation();

        allowDrawerClose = true;

        const onToggle = () => {
          if (!mobileDrawer.open) {
            body.classList.remove('facet-drawer--open');
            body.classList.add('facet-drawer--closing');

            setTimeout(() => {
              body.classList.remove('facet-drawer--closing');
            }, 200);

            mobileDrawer.removeEventListener('toggle', onToggle);
            allowDrawerClose = false;
          }
        };

        mobileDrawer.addEventListener('toggle', onToggle);
        mobileSummary.click();
      });



      // Hide chips while user tweaks facets
      if (typeof facetContainerMobile !== 'undefined' && facetContainerMobile) {
        ['change', 'click'].forEach(evt => {
          facetContainerMobile.addEventListener(evt, (e) => {
            if (e.target.closest('.mobile-facets__footer')) return;
            hideActiveFacets();
          }, true);
        });
      }

      // APPLY button
      document.addEventListener('click', (e) => {
        const applyBtn = e.target.closest('.mobile-facets__footer .button');
        if (!applyBtn || !mobileDrawer || !mobileSummary) return;
        if (applyBtn.closest('.aa-PanelLayout') || applyBtn.closest('.autocomplete-facets-mobile') || applyBtn.classList.contains('acp_mobile_apply_btn')) return;

        showActiveFacets();

        allowDrawerClose = true;

        const onToggle = () => {
          if (!mobileDrawer.open) {
            body.classList.remove('facet-drawer--open');
            body.classList.add('facet-drawer--closing');

            setTimeout(() => {
              body.classList.remove('facet-drawer--closing');
            }, 200);

            // cleanup listener
            mobileDrawer.removeEventListener('toggle', onToggle);
            allowDrawerClose = false;
          }
        };

        mobileDrawer.addEventListener('toggle', onToggle);
        mobileSummary.click();
      });


      // CLEAR button
      document.addEventListener('click', (e) => {
        const clearLink = e.target.closest('.mobile-facets__clear');
        if (!clearLink) return;
        if (clearLink.closest('.aa-PanelLayout') || clearLink.closest('.autocomplete-facets-mobile') || clearLink.classList.contains('ap_mobile_clear_btn')) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (search?.helper) {
          search.helper.clearRefinements().search();
        }

        const activeList = document.querySelector('.active-facets__list');
        if (activeList) activeList.innerHTML = '';
      }, true);
    }

    // Run if <= 750px
    const mq = window.matchMedia("(max-width: 750px)");
    if (mq.matches) initMobileFacets();



  });




  const activeFacetsWrapper = document.querySelector('.active-facets-wrapper');
  if (activeFacetsWrapper) {
    search.addWidgets([
      instantsearch.widgets.currentRefinements({
        container: activeFacetsWrapper,
        includedAttributes: facets.map(f => f.name),
        transformItems(items) {
          const facetMap = Object.fromEntries(facets.map(f => [f.name, f.title || f.name]));
          const container = document.querySelector('.ais-CurrentRefinements-active-facets');
          const mobileContainer = document.querySelector('.active-facets-mobile');
          const totalRefinements = items.reduce((sum, it) => sum + (it.refinements ? it.refinements.length : 0), 0);

          const hasActiveFilters = items.some(item => item.refinements.length > 0);
          if (container) {
            container.classList.toggle('hidden', !hasActiveFilters);
          }
          if (mobileContainer) {
            if (totalRefinements > 0) {
              mobileContainer.classList.add('multi');
            } else {
              mobileContainer.classList.remove('multi');
            }
          }
          return items.map(item => ({
            ...item,
            refinements: item.refinements.map(ref => ({
              ...ref,
              label: `${facetMap[item.attribute] || item.attribute}: ${ref.label}`,
            })),
          }));
        },
        templates: {
          item({ refinements, refine }) {
            return refinements
              .map(
                (refinement, idx) => `
                  <li class="inline-block mr-2 mb-2">
                    <button
                      class="text-sm text-black border border-gray-300 rounded-full px-3 py-1 hover:bg-gray-100"
                      type="button"
                      aria-label="Remove ${refinement.label}"
                      onclick="event.preventDefault(); window.__refine${idx}()"
                    >
                      ✕ ${refinement.label}
                    </button>
                  </li>
                  <script>
                    window.__refine${idx} = ${refine.toString()}.bind(null, ${JSON.stringify(refinement)});
                  </script>
                `
              )
              .join('');
          },
        },
      }),
    ]);
  }
  // search.addWidgets([
  //   instantsearch.widgets.clearRefinements({
  //     container: '.ais-CurrentRefinements-active-facets',
  //     templates: {
  //       resetLabel: '✕ Clear All'
  //     },
  //     cssClasses: {
  //       button: 'ais-ClearRefinements-button text-sm font-medium text-red-500 mb-2 underline'
  //     }
  //   })
  // ]);

  // Add Clear All inside the parent
  // Remove the separate clearRefinements widget (don’t call it directly on #clear-refinements)

  (function setupSingleLiCurrentRefinements() {
    const containerEl = document.querySelector('#current-refinements');
    const mobileCountEl = document.querySelector('.Selected_fc'); // ✅ target element in facet drawer

    function esc(str) {
      return String(str).replace(/[&<>"']/g, s =>
        ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[s])
      );
    }

    const render = ({ items = [], refine, widgetParams, instantSearchInstance }) => {
      if (!containerEl) return;

      const allRefinements = items.flatMap(item => {
        let cleanedName = item.attribute.replace(/^options\./, '');

        // 1. Try translation from window.algoliaShopify.translations.facets
        let translatedName = null;
        if (window.algoliaShopify && window.algoliaShopify.translations && window.algoliaShopify.translations.facets) {
          const trans = window.algoliaShopify.translations.facets;
          const lookupKey = cleanedName.charAt(0).toUpperCase() + cleanedName.slice(1);
          translatedName = trans[lookupKey] || trans[cleanedName];
        }

        // 2. Fallback to facetTitleMap if available not translated
        if (translatedName) {
          cleanedName = translatedName;
        } else if (typeof facetTitleMap !== 'undefined' && facetTitleMap[item.attribute]) {
          cleanedName = facetTitleMap[item.attribute];
        }

        return (item.refinements || []).map(r => {
          let displayValue = r.label;
          if (window.algoliaShopify && window.algoliaShopify.translations && window.algoliaShopify.translations.facetValues) {
            const trans = window.algoliaShopify.translations.facetValues;
            if (trans[r.label]) displayValue = trans[r.label];
          }

          return {
            ...r,
            label: `${cleanedName}: ${displayValue}`,
          };
        });
      });

      const count = allRefinements.length; // ✅ total refinements count

      // ✅ Update mobile filter count <span class="Selected_fc"></span>
      if (mobileCountEl) {
        if (count > 0) {
          mobileCountEl.textContent = `(${count})`;
          mobileCountEl.style.display = 'inline';
        } else {
          mobileCountEl.textContent = '';
          mobileCountEl.style.display = 'none';
        }
      }

      if (!count) {
        containerEl.innerHTML = '';
        return;
      }

      // build chips
      const chipsHtml = allRefinements.map((r, i) => `
      <span class="ais-CurrentRefinements-category inline-block mr-2 mb-2">
        <button type="button"
                class="ais-CurrentRefinements-delete inline-flex items-center px-3 py-1 rounded-full border text-sm"
                data-chip-index="${i}"
                aria-label="Remove ${esc(r.label)}">
          ✕ ${esc(r.label)}
        </button>
      </span>
    `).join('');

      const clearAllHtml = `
      <div id="clear-refinements" class="flex items-center justify-between mb-2">
        <div class="ais-ClearRefinements">
          <button class="ais-ClearRefinements-button text-sm font-medium text-red-500 underline">
            ✕ ${window.algoliaShopify.translations.clearAll || 'Clear All'}
          </button>
        </div>
        <span class="text-sm text-gray-600 ml-3 hidden selected-fc_hide">(${count})</span>
      </div>
    `;

      containerEl.innerHTML = `
      <ul class="ais-CurrentRefinements-list">
        <li class="ais-CurrentRefinements-item">
          ${clearAllHtml}
          ${chipsHtml}
        </li>
      </ul>
    `;

      // attach refine event to each chip
      allRefinements.forEach((r, i) => {
        const btn = containerEl.querySelector(`[data-chip-index="${i}"]`);
        if (!btn) return;
        const newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);
        newBtn.addEventListener('click', ev => {
          ev.preventDefault();
          refine(r);
        });
      });

      // attach Clear All manually
      const clearBtn = containerEl.querySelector('.ais-ClearRefinements-button');
      if (clearBtn) {
        clearBtn.addEventListener('click', ev => {
          ev.preventDefault();
          allRefinements.forEach(r => refine(r));
        });
      }
    };

    const connected = instantsearch.connectors.connectCurrentRefinements(render);
    if (containerEl) {
      search.addWidgets([connected({ container: containerEl })]);
    }
  })();



  const DefaultFacetContainer = document.querySelector("facet-filters-form");
  if (DefaultFacetContainer) DefaultFacetContainer.innerHTML = "";
  const DefaultFacetContainerMobile = document.querySelector(".mobile-facets__main");
  if (DefaultFacetContainerMobile) DefaultFacetContainerMobile.innerHTML = "";
}

// clear existing default content (if present)
const pcDesktop = document.querySelector("#ProductCount");
if (pcDesktop) pcDesktop.innerHTML = "";

const pcMobile = document.querySelector("#ProductCountMobile");
if (pcMobile) pcMobile.innerHTML = "";

// stats widget factory
function makeStatsWidget(containerSelector) {
  return instantsearch.widgets.stats({
    container: containerSelector,
    templates: {
      text: ({ nbHits }) => {
        let label = "products";
        if (window.algoliaShopify && window.algoliaShopify.translations && window.algoliaShopify.translations.products) {
          label = window.algoliaShopify.translations.products;
        }
        return `${nbHits.toLocaleString()} ${label}`;
      },
    },
  });
}

// collect widgets only for containers that exist (and avoid duplicate same element)
const statsWidgets = [];
if (pcDesktop) statsWidgets.push(makeStatsWidget("#ProductCount"));
if (pcMobile && pcMobile !== pcDesktop) statsWidgets.push(makeStatsWidget("#ProductCountMobile"));

// register widgets (if any)
if (statsWidgets.length) {
  search.addWidgets(statsWidgets);
}


// Declare DOM references first

// start infinite scroll start

// window.algoliaShopify = window.algoliaShopify || {};
const productGridContainer = document.querySelector("#ProductGridContainer");
if (productGridContainer) {
  search.addWidgets([
    instantsearch.widgets.infiniteHits({
      container: productGridContainer,
      templates: {
        item(hit, { html, components }) {
          // return window.algoliaShopify.instantSearchProductTemplate(
          //   hit,
          //   html,
          //   components
          // );
          if (typeof window.algoliaShopify.instantSearchProductTemplate === 'function') {
            // return window.algoliaShopify.instantSearchProductTemplate(hit, html, components);
            const markup = window.algoliaShopify.instantSearchProductTemplate(hit, html, components);


            requestAnimationFrame(() => {
              const wrapper = document.querySelector(
                `.gallery_wrapper-custom[data-product-handle="${hit.handle}"]`
              );
              if (wrapper && !wrapper.dataset.initialized) {
                wrapper.dataset.initialized = "true";
                const prefix =
                  window.Shopify?.locale &&
                    /^ar(\b|-|_)/i.test(window.Shopify.locale)
                    ? "/ar"
                    : "";
                const url = `${prefix}/products/${hit.handle}?view=swatches`;
                if (typeof loadSwatches === 'function') {
                  loadSwatches(hit.handle, url);
                }
              }
            });

            return markup;
          }
          // console.error('instantSearchProductTemplate is not defined');
          return '';
        },
        loadMore({ isLastPage }) {
          return `
          <div class="ais-InfiniteHits-loadMore infinite-loader-wrapper">
            <button class="load-more-btn" ${isLastPage ? 'disabled' : ''}></button>
          </div>
        `;
        }
      },
      cssClasses: {
        root: "ais-InfiniteHits",
        list: "ais-InfiniteHits-list",
        item: "ais-InfiniteHits-item",
      },
      transformItems(items) {
        const seen = new Set();
        return items.filter((item) => {
          const key = item.handle; // product-level key
          if (seen.has(key)) {
            return false; // skip duplicate variants
          }
          seen.add(key);
          return true; // keep only the first variant per product
        });
      },
    }),
  ]);
}


// Auto load more on scroll
function setupLoadMoreSpinnerLoop() {
  const container = document.querySelector("#ProductGridContainer");
  if (!container) return;

  const timeouts = new WeakMap(); // track timeouts per element

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const wrapper = entry.target;
        if (entry.isIntersecting) {
          if (!timeouts.has(wrapper)) {
            // Add class
            wrapper.classList.add("infinite-loader-spinner");

            // Trigger click immediately
            wrapper.click();

            // Remove class after 3s
            const timeoutId = setTimeout(() => {
              wrapper.classList.remove("infinite-loader-spinner");
              timeouts.delete(wrapper); // allow next cycle
            }, 300);

            timeouts.set(wrapper, timeoutId);
          }
        }
      });
    },
    {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    }
  );


  const observeWrappers = () => {
    const wrappers = container.querySelectorAll(".ais-InfiniteHits-loadMore");
    wrappers.forEach((wrapper) => observer.observe(wrapper));
  };

  observeWrappers();

  // Observe newly added buttons
  const mo = new MutationObserver(observeWrappers);
  mo.observe(container, { childList: true, subtree: true });
}

setupLoadMoreSpinnerLoop();



document.querySelectorAll('.list-view__item').forEach(item => {
  item.addEventListener('click', function () {
    const layoutMode = this.getAttribute('data-layout-mode');

    const listContainer = document.querySelector('.ais-InfiniteHits-list.ais-InfiniteHits-list');

    // Remove 'active' class from all buttons
    document.querySelectorAll('.list-view__item').forEach(btn => {
      btn.classList.remove('list-view__item--active');
    });

    // Add 'active' class to clicked button
    this.classList.add('list-view__item--active');

    if (listContainer && layoutMode) {
      // Reset base classes
      listContainer.className = 'ais-InfiniteHits-list ais-InfiniteHits-list';

      // Apply layout-specific class
      if (layoutMode === 'grid-2' || layoutMode === 'grid-3') {
        listContainer.classList.add(`ais-custom-layout-${layoutMode}`);
      }
    }
  });
});

// start infinite scroll end
//------------------------------------Filter load end--------------------------------------------------------

const customSortBy = instantsearch.connectors.connectSortBy(
  (renderOptions, isFirstRender) => {
    const { options, currentRefinement, refine, widgetParams } = renderOptions;
    const container = widgetParams.container;

    if (isFirstRender) {
      container.addEventListener("click", (e) => {
        const li = e.target.closest("li[data-value]");
        if (li) {
          refine(li.dataset.value);

          // Update URL
          const url = new URL(window.location.href);
          if (li.dataset.value === options[0].value) {
            url.searchParams.delete("sortBy");
          } else {
            url.searchParams.set("sortBy", li.dataset.value);
          }
          window.history.replaceState(null, "", url.toString());

          // Update active class
          container.querySelectorAll("li").forEach((el) =>
            el.classList.remove("active")
          );
          li.classList.add("active");
        }
      });
    }

    container.innerHTML = `
      <div class="custom-sortby ais-SortBy">
        <span class="sortby-toggle"><span>${algoliaShopify.translations && algoliaShopify.translations.sortBy || "Sort by"}</span><span class="sort_mob_span">${algoliaShopify.translations && algoliaShopify.translations.sort || "Sort"}</span>
        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" fill="none" viewBox="0 0 24 15">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"></path>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" class="sortby_mob_svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
        <path d="M2.9834 14.0772L0.711409 11.8035C0.548753 11.6407 0.284935 11.6406 0.122153 11.8033C-0.0406284 11.9659 -0.0407307 12.2297 0.121925 12.3925L3.10514 15.378C3.18328 15.4562 3.28931 15.5002 3.39988 15.5002C3.51044 15.5002 3.61647 15.4562 3.69462 15.378L6.67783 12.3925C6.84049 12.2297 6.84038 11.9659 6.6776 11.8033C6.51482 11.6406 6.251 11.6407 6.08835 11.8035L3.81673 14.0769V0.916667C3.81673 0.686548 3.63018 0.5 3.40006 0.5C3.16995 0.5 2.9834 0.686548 2.9834 0.916667V14.0772Z" fill="#303030"/>
        <path d="M15.0035 2.40791C15.0035 2.17779 14.8169 1.99124 14.5868 1.99124H7.87457C7.64445 1.99124 7.4579 2.17779 7.4579 2.40791C7.4579 2.63803 7.64445 2.82458 7.87457 2.82458H14.5868C14.8169 2.82458 15.0035 2.63803 15.0035 2.40791Z" fill="#303030"/>
        <path d="M12.3932 5.39021C12.3932 5.1601 12.2066 4.97355 11.9765 4.97355H7.87461C7.64449 4.97355 7.45794 5.1601 7.45794 5.39021C7.45794 5.62033 7.64449 5.80688 7.87461 5.80688H11.9765C12.2066 5.80688 12.3932 5.62033 12.3932 5.39021Z" fill="#303030"/>
        <path d="M9.36625 7.95603C9.59637 7.95603 9.78292 8.14258 9.78292 8.3727C9.78292 8.60282 9.59637 8.78936 9.36625 8.78936H7.87465C7.64453 8.78936 7.45798 8.60282 7.45798 8.3727C7.45798 8.14258 7.64453 7.95603 7.87465 7.95603H9.36625Z" fill="#303030"/>
        </svg>
        </span>
        <ul class="sortby-options">
          ${options
        .map(
          (opt) => {
            let label = opt.label;
            if (window.algoliaShopify && window.algoliaShopify.translations && window.algoliaShopify.translations.sortOptions) {
              const t = window.algoliaShopify.translations.sortOptions;
              if (t[label]) label = t[label];
              else if (t[label.trim()]) label = t[label.trim()];
            }
            return `

              <li 
                data-value="${opt.value}" 
                class="sort-orders_type ${opt.value === currentRefinement ? "active" : ""}"
              >
                ${label}
              </li>`
          }
        )
        .join("")}
        </ul>
      </div>
    `;
  }
);

// Add widget
const sortByContainer = document.querySelector("#sort-by-container");
if (sortByContainer) {
  search.addWidgets([
    customSortBy({
      container: sortByContainer,
      items:
        window.algoliaShopify.collectionSortOrders ||
        window.algoliaShopify.sortOrders || [
          { label: "Relevance", value: "shopify_products" },
        ],
    }),
  ]);
}


function applySortFromURL() {
  const urlSort = new URL(window.location.href).searchParams.get("sortBy");
  if (!urlSort) return;

  const li = document.querySelector(
    `.custom-sortby li[data-value="${urlSort}"]`
  );
  if (li) li.click(); // triggers refine + URL update + active state
}

document.addEventListener("DOMContentLoaded", applySortFromURL);
// const activeFacets = window.algoliaShopify.config.collection_facets || window.algoliaShopify.config.facets;



search.start();
document.addEventListener("click", function (e) {
  const sortContainer = document.querySelector("#sort-by-container");
  if (!sortContainer) return;

  const toggle = sortContainer.querySelector(".sortby-toggle");
  const options = sortContainer.querySelector(".sortby-options");

  if (!toggle || !options) return;

  // Click on toggle
  if (e.target.closest(".sortby-toggle")) {
    e.stopPropagation();
    options.classList.toggle("open");
    return;
  }

  // Click outside closes
  if (!sortContainer.contains(e.target)) {
    options.classList.remove("open");
  }
});


// ✅ Get current index based on sortBy selection
function getCurrentIndex() {
  const sortByContainer = document.querySelector('.custom-sortby.ais-SortBy');
  if (!sortByContainer) {
    return `${window.algoliaShopify.config.index_prefix}products`;
  }

  const activeOption = sortByContainer.querySelector('.sort-orders_type.active');
  if (!activeOption) {
    return `${window.algoliaShopify.config.index_prefix}products`;
  }

  const dataValue = activeOption.getAttribute('data-value');

  // Return the index name directly from data-value
  return dataValue || `${window.algoliaShopify.config.index_prefix}products`;
}

// ✅ Track already-sent IDs so we don't send duplicates
const alreadySentObjectIDs = new Set();

// ✅ Send viewedObjectIDs in chunks to avoid 422 errors
function sendViewedObjectIDs(sendAll = false) {
  const productEls = document.querySelectorAll("[data-algolia-objectid]");
  if (!productEls.length) return;

  const objectIDs = Array.from(productEls)
    .map(el => el.dataset.algoliaObjectid)
    .filter(Boolean);

  // If sendAll flag is true, send all IDs regardless of previous sends
  const IDsToSend = sendAll ? objectIDs : objectIDs.filter(id => !alreadySentObjectIDs.has(id));
  if (!IDsToSend.length) return;

  // Mark them as sent
  IDsToSend.forEach(id => alreadySentObjectIDs.add(id));

  // 🔥 CHUNK THE OBJECTIDS TO AVOID 422 ERRORS
  const CHUNK_SIZE = 20; // Algolia's safe limit
  const chunks = [];

  for (let i = 0; i < IDsToSend.length; i += CHUNK_SIZE) {
    chunks.push(IDsToSend.slice(i, i + CHUNK_SIZE));
  }

  const events = chunks.map(chunk => {
    // ✅ Prepare the event object
    const event = {
      eventType: "view",
      eventName: "viewedObjectIDs",
      index: getCurrentIndex(),
      userToken: getUserToken(),
      objectIDs: chunk,
    };

    // ✅ Add authenticatedUserToken if available
    const authenticatedToken = getAuthenticatedUserToken();
    if (authenticatedToken) {
      event.authenticatedUserToken = authenticatedToken;
    }

    return event;
  });

  console.log(`[Algolia Insights] viewedObjectIDs sent in ${chunks.length} chunks:`, {
    IDsToSend,
    authenticatedUserToken: getAuthenticatedUserToken() || 'none'
  });

  // Send all chunks
  events.forEach(event => {
    aa("sendEvents", [event]);
  });
}

// ✅ Run once after DOM load
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => sendViewedObjectIDs(false), 200);

  // 🔁 Re-run whenever Algolia updates hits
  // 🔁 Re-run whenever Algolia updates hits (works on filters, sorts, pagination, etc.)
  if (window.search && typeof window.search.on === "function") {
    let lastRenderTime = 0;
    search.on("render", () => {
      const now = Date.now();
      // debounce a bit to prevent multiple fires on the same render frame
      if (now - lastRenderTime > 300) {
        lastRenderTime = now;
        setTimeout(() => sendViewedObjectIDs(false), 300);
      }
    });
  } else {
    // Fallback for cases without InstantSearch event access
    const hitsContainer = document.querySelector("#algolia-hits");
    if (hitsContainer) {
      const observer = new MutationObserver(() => {
        setTimeout(() => sendViewedObjectIDs(false), 300);
      });
      observer.observe(hitsContainer, { childList: true, subtree: true });
    }
  }

});

// -------------------------------
// Run viewedObjectIDs whenever the URL changes (SPA navigation / filters / sort / show more)
// -------------------------------
(function () {
  // debounce + small rendering wait to avoid racing with InstantSearch rendering
  let debounceTimer = null;
  function scheduleSendViewedObjectIDs(sendAll = false) {
    if (debounceTimer) clearTimeout(debounceTimer);
    // short debounce so rapid URL updates don't spam events
    debounceTimer = setTimeout(() => {
      // give InstantSearch / DOM a bit of time to update
      setTimeout(() => {
        try {
          if (typeof sendViewedObjectIDs === "function") {
            sendViewedObjectIDs(sendAll);
          }
        } catch (err) {
          console.error("Error while sending viewedObjectIDs:", err);
        }
      }, 600); // tweak this delay (600ms) if you need it shorter/longer
    }, 250);
  }
  // monkeypatch history methods to emit a custom event
  const _pushState = history.pushState;
  const _replaceState = history.replaceState;

  history.pushState = function () {
    const result = _pushState.apply(this, arguments);
    window.dispatchEvent(new CustomEvent("locationchange", { detail: { isFilterOrSort: false } }));
    return result;
  };

  history.replaceState = function () {
    const result = _replaceState.apply(this, arguments);
    window.dispatchEvent(new CustomEvent("locationchange", { detail: { isFilterOrSort: false } }));
    return result;
  };

  // handle back/forward + hash changes
  window.addEventListener("popstate", () => window.dispatchEvent(new CustomEvent("locationchange", { detail: { isFilterOrSort: false } })));
  window.addEventListener("hashchange", () => window.dispatchEvent(new CustomEvent("locationchange", { detail: { isFilterOrSort: false } })));

  // handle the custom event
  window.addEventListener("locationchange", (event) => {
    scheduleSendViewedObjectIDs(event.detail && event.detail.isFilterOrSort);
  });

  // Listen for filter/sort interactions
  function setupFilterSortListeners() {
    // Select all filter and sort elements - update these selectors based on your implementation
    const filterSelectors = [
      '[class*="filter"]',
      '[class*="sort"]',
      '[class*="refinement"]',
      '.ais-RefinementList',
      '.ais-SortBy',
      '.ais-HierarchicalMenu',
      '.ais-Menu',
      '.ais-NumericMenu',
      '.ais-RatingMenu',
      '.ais-ToggleRefinement'
    ];

    const filterElements = document.querySelectorAll(filterSelectors.join(','));

    filterElements.forEach(element => {
      // Remove existing listeners to avoid duplicates
      element.removeEventListener('click', handleFilterSortClick);
      element.removeEventListener('change', handleFilterSortChange);

      // Add new listeners
      if (element.tagName === 'SELECT') {
        element.addEventListener('change', handleFilterSortChange);
      } else {
        element.addEventListener('click', handleFilterSortClick);
      }
    });
  }

  function handleFilterSortClick(e) {
    // Ignore clicks on the sort toggle itself
    if (e.target.closest(".sortby-toggle") || e.target.closest(".custom-sortby__button")) return;

    const target = e.target.closest(".sort-orders_type, [class*='sort'], [class*='filter']");
    if (!target) return;

    // Ignore "Show more" buttons
    if (e.target.closest("#algolia-facets-container .button-show-more")) return;

    // ✅ Reset already sent object IDs for new sort selection
    if (target.classList.contains("sort-orders_type")) {
      alreadySentObjectIDs.clear();
    }

    // Dispatch locationchange for SPA handling
    window.dispatchEvent(new CustomEvent("locationchange", { detail: { isFilterOrSort: true } }));
  }


  function handleFilterSortChange() {
    window.dispatchEvent(new CustomEvent("locationchange", { detail: { isFilterOrSort: true } }));
  }

  // Set up initial listeners
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(setupFilterSortListeners, 1000);
  });

  // Also set up listeners after DOM changes (for SPAs)
  const observer = new MutationObserver(() => {
    setupFilterSortListeners();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();